import BoldText from '@/components/BoldText';
import LayoutSettings from '@/components/LayoutSetting/LayoutSettings';
import { SpecificType } from '@/constants/enum';
import SpecificDatePicker from '@/pages/PickupSetting/component/PickupAvailability/PickupDatePicker/SpecificDatePicker';
import SpecificDateTable from '@/pages/PickupSetting/component/PickupAvailability/PickupDatePicker/SpecificDateTable';
import { handleSavePickupHolidays, pickupHolidaySelector } from '@/redux/slice/pickup.slice';
import { IHoliday, ISpecificWorkingDay } from '@/types/components/day';
import { groupDatesByYearMonthDay, specificDateProcess } from '@/utils';
import { BlockStack, Button, InlineGrid } from '@shopify/polaris';
import { PlusIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const BlackoutDate = () => {
  const { t } = useTranslation('pickupSettings');
  const pickupHolidays = useSelector(pickupHolidaySelector);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [currentDateRange, setCurrentDateRange] = useState<{ start: Date; end: Date } | undefined>();

  const handleOnAddDates = () => {
    if (!currentDateRange) {
      return;
    }
    const groupedDates = groupDatesByYearMonthDay(currentDateRange);

    const mergedSpecificDays = specificDateProcess(groupedDates, pickupHolidays);

    const mergedSpecificWorkingDays = mergedSpecificDays.map((item, index) => ({
      id: index + 1,
      settingId: Number(id),
      year: item.year,
      month: item.month,
      dates: item.dates,
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
    }));

    dispatch(handleSavePickupHolidays(mergedSpecificWorkingDays));
    setCurrentDateRange(undefined);
  };

  const handleSetSpecificDates = (data: ISpecificWorkingDay[] | IHoliday[]) =>
    dispatch(handleSavePickupHolidays(data));

  return (
    <LayoutSettings title={t('blackoutDate.heading')} helpText={t('blackoutDate.description')}>
      <BlockStack gap="400">
        <BoldText>{t('blackoutDate.sectionTitle')}</BoldText>
        <InlineGrid columns="1fr auto" gap="200">
          <SpecificDatePicker dateRange={currentDateRange} setDateRange={setCurrentDateRange} type={SpecificType.BLACKOUT} />
          <Button icon={PlusIcon} onClick={handleOnAddDates} disabled={!currentDateRange} fullWidth>
            {t('blackoutDate.actions.add')}
          </Button>
        </InlineGrid>
        <SpecificDateTable
          specificDates={pickupHolidays}
          handleSetSpecificDates={handleSetSpecificDates}
          type={SpecificType.BLACKOUT}
        />
      </BlockStack>
    </LayoutSettings>
  );
};

export default BlackoutDate;
